<template>
	<div id="cdn" class="mt-5">
		<div class="row mb-5">
			<div class="col-md-2"></div>
			<div class="col-md-5">
				<input type="file" accept="any/*" @change="onImageSelected" />
			</div> 
			<div class="col-md-2">
				<b-button @click="uploadImage">Upload</b-button>
			</div> 
			<div class="col-md-2">
				<b-button @click="listFiles">Refresh</b-button>
			</div>
		</div>
		<div class="row mb-1" v-for="f in filtered" :key="f.fileName">
			<div class="col-md-2"></div>
			<div class="col-md-2">
				<p>{{f.lastModifiedDateTime}}</p>
			</div>
			<div class="col-md-4">
				<a :href="f.uri" target="_blank">{{f.uri}}</a>
			</div>
			<div class="col-md-4" style="text-align: right">
				<b-img :src="f.uri" height="60"></b-img>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  name: 'Upload',
  data() {
	return{
		image: '',
		fileName: '',
		lastModifiedDateTime: '',
		uri: '',
		files: null
	}
  },
	computed: {
		filtered() {
			if (!this.files) { return null; }
			return this.files.filter(f => { return f.fileName.toLowerCase().includes(".jpg") ||
				f.fileName.toLowerCase().includes(".png") ||
				f.fileName.toLowerCase().includes(".gif") ||
				f.fileName.toLowerCase().includes(".mp4") ||
				f.fileName.toLowerCase().includes(".svg") ||
				f.fileName.toLowerCase().includes(".pdf")
			});
		}
	},
	methods: {
		onImageSelected(e) {
			var file = e.target.files[0];
			this.fileName = file.name;
			this.getBase64(file);
		},
		getBase64(file) {
			var reader = new FileReader();
			reader.onload = (e) => {
				this.image = e.target.result.split(',')[1];
			};
			reader.readAsDataURL(file);
		},
		uploadImage() {
			this.$http.post(this.$config.ApiUri + "/CMS/Files/UploadRequests", { "content" : this.image, "fileName": this.fileName })
				.then((result) => {
					this.uri = result.data.uri;
					alert("OK");
					this.listFiles();
				}
			)
		},
		listFiles: function(){
			this.$http.get(this.$config.ApiUri + "/CMS/Files?ordered=true")
				.then((result) => {
					this.files = result.data;
					//alert(this.files);
				}
			)
		},
		onLoad() {
			this.listFiles();
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

</style>